(() => {
  if (window.__nextylTileVariantResolverLoaded) return;
  window.__nextylTileVariantResolverLoaded = true;


  const supplierHoldIds = new Set(["53555725893908","53555725926676","53555726287124","53424505979156","53424507126036","53615110979860","53615111012628","53615111045396","53556019265812","53556019757332","53556020117780","53556020150548","53558577660180","53558577692948","53559114039572","53559114137876","53559114236180","53555726090516","53555726123284","53555726156052","53555726352660","53555726385428","53555726549268","53558552297748","53558552330516","53558552559892","53558552592660","53558552822036","53558552854804"]);
  const preparePicker = (picker) => {
    const node = picker.querySelector('[data-nextyl-product-variants]');
    if (!node) return;
    let variants;
    try { variants = JSON.parse(node.textContent); } catch (_) { return; }
    const allowed = variants.filter((variant) => !supplierHoldIds.has(String(variant.id)));
    node.textContent = JSON.stringify(allowed);
    const groups = Array.from(picker.querySelectorAll(':scope > .product-form__input')).filter(
      (group) => group.querySelector('input[type="radio"], select')
    );
    groups.forEach((group, index) => {
      group.querySelectorAll('input[type="radio"], select option').forEach((input) => {
        if (allowed.some((variant) => variant.options[index] === input.value)) return;
        input.disabled = true;
        input.hidden = true;
        input.style.display = 'none';
        if (input.tagName === 'INPUT') {
          const label = group.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (label) label.style.display = 'none';
        }
      });
    });
    let selected;
    try { selected = JSON.parse(picker.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch (_) {}
    if (selected && supplierHoldIds.has(String(selected.id))) {
      const info = picker.closest('product-info');
      if (allowed.length) {
        if (info) info.style.visibility = 'hidden';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', allowed[0].id);
        window.location.replace(url.href);
      } else {
        picker.hidden = true;
        info?.querySelectorAll('[data-tile-quote-open], [data-tile-sample-open], button[name="add"]').forEach((button) => {
          button.disabled = true;
        });
      }
    }
  };
  const preparePickers = () => document.querySelectorAll('variant-selects[data-nextyl-quote-product="true"]').forEach(preparePicker);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparePickers);
  else preparePickers();
  document.addEventListener('shopify:section:load', preparePickers);

  document.addEventListener('change', (event) => {
    const picker = event.target.closest('variant-selects[data-nextyl-quote-product="true"]');
    if (!picker) return;
    event.stopImmediatePropagation();

    const groups = Array.from(picker.querySelectorAll(':scope > .product-form__input')).filter(
      (group) => group.querySelector('input[type="radio"], select')
    );
    const selected = groups.map((group) => group.querySelector('input:checked, select')?.value || null);
    const changedIndex = groups.indexOf(event.target.closest('.product-form__input'));
    const variantsNode = picker.querySelector('[data-nextyl-product-variants]');
    if (changedIndex < 0 || !variantsNode) return;

    let variants;
    try { variants = JSON.parse(variantsNode.textContent).filter((variant) => !supplierHoldIds.has(String(variant.id))); } catch (_) { return; }

    const exact = variants.find((variant) =>
      variant.options.length === selected.length &&
      variant.options.every((value, index) => value === selected[index])
    );
    const candidates = variants.filter((variant) => variant.options[changedIndex] === event.target.value);
    const resolved = exact || candidates
      .map((variant, order) => ({
        variant,
        order,
        score: variant.options.reduce(
          (score, value, index) => score + (index !== changedIndex && value === selected[index] ? 1 : 0),
          0
        )
      }))
      .sort((a, b) => b.score - a.score || a.order - b.order)[0]?.variant;
    if (!resolved) return;

    groups.forEach((group, index) => {
      const value = resolved.options[index];
      const select = group.querySelector('select');
      if (select) {
        select.value = value;
        Array.from(select.options).forEach((option) => option.toggleAttribute('selected', option.value === value));
      } else {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = input.value === value;
        });
      }
      const label = group.querySelector('[data-selected-value], [data-selected-swatch-value]');
      if (label) label.textContent = value;
    });

    const selectedVariantNode = picker.querySelector('[data-selected-variant]');
    if (selectedVariantNode) selectedVariantNode.textContent = JSON.stringify(resolved);

    const productInfo = picker.closest('product-info');
    if (productInfo) {
      productInfo.currentVariant = resolved;

      const skuValue = productInfo.querySelector('[id^="Sku-"] span:last-child');
      if (skuValue) skuValue.textContent = resolved.sku || '';

      if (typeof productInfo.updateURL === 'function') {
        productInfo.updateURL(productInfo.dataset.url, resolved.id);
      } else if (picker.dataset.updateUrl !== 'false') {
        window.history.replaceState({}, '', picker.dataset.url + '?variant=' + resolved.id);
      }

      if (typeof productInfo.updateShareUrl === 'function') productInfo.updateShareUrl(resolved.id);
      if (typeof productInfo.updateVariantInputs === 'function') productInfo.updateVariantInputs(resolved.id);
      if (typeof productInfo.updateMedia === 'function') productInfo.updateMedia(resolved);
    }

    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: resolved } }));
  }, true);

  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    const picker = document.querySelector('variant-selects[data-nextyl-quote-product="true"]');
    const productInfo = picker?.closest('product-info');
    const skuValue = productInfo?.querySelector('[id^="Sku-"] span:last-child');
    if (skuValue) skuValue.textContent = variant.sku || '';
  });
})();
